import React from "react";
import "./Perks.scss";
import PerksData from "../../ComponentAPI/perksAPI";

const Perks = () => {
  return (
    <section className="perks">
      <div className="container">
        <div className="perks-available">
          {PerksData.map((item) => (
            <div className="perks-available__wrap" key={item?.id}>
              <div className="perks-available__wrap-circle">
                <img src={item?.image} alt={item?.text} loading="lazy" />
              </div>
              <p>{item?.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Perks;
